export default "__VITE_ASSET__Ch87p8si__"